


















import { Component, Vue } from 'vue-property-decorator'
import ListItem from './ListItem.vue'
import EmptyPlaceholder from './EmptyPlaceholder.vue'
import { State } from 'vuex-class'

@Component({
  name: 'Sheets',
  components: {
    ListItem,
    EmptyPlaceholder,
  },
})
export default class Item extends Vue {
  @State sheetList: any

  get seasonList() {
    const { seasons = [] } = this.sheetList
    return seasons
  }
}
